import { useDispatch, useSelector } from 'react-redux';
import { setActiveDashboardId } from '@store/dashboards/ui/actions';
import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';
import commonSelector from '@store/common/selectors';

import { useDefaultLandingPageStore, usePromptStore } from '@globalStore/defaultLandingPageStore';
import { useDefaultLandingPageMutation } from '@hooks/useDefaultLandingPage';

export function useDefaultHandler() {
  const dispatch = useDispatch();
  const { profiles } = useSelector(commonSelector);

  const defaultLandingPage = useDefaultLandingPageStore((state) => ({
    url: state.url,
    name: state.name,
    path: state.path,
  }));

  const { setDefaultLandingPage: mutateLandingPage } = useDefaultLandingPageMutation();

  const { openPrompt, closePrompt, setPromptState } = usePromptStore();

  const cid = profiles.filter((p) => p.is_selected)[0].customer_id;

  const onSetDefaultLandingApply = () => {
    const { pathname } = window.location;
    dispatch(setActiveDashboardId(null));
    const arr = pathname.split('/');
    const u = getActualShareLink(pathname, cid);

    mutateLandingPage({
      url: u,
      name: arr[arr.length - 1],
      path: pathname,
    });
  };

  const hasDefaultLandingPage = defaultLandingPage.url.length > 0;
  const dlpTitle = 'Make default';
  const dlpNeedInput = false;
  const dlpContent = hasDefaultLandingPage
    ? 'Are you sure you want to change your default dashboard?'
    : 'Are you sure you want to set your default dashboard?';
  const dlpOkFn = () => onSetDefaultLandingApply();

  const onSetDefaultLanding = () => {
    dispatch(setActiveDashboardId(null));
    setPromptState({
      promptNeedInput: dlpNeedInput,
      promptTitle: dlpTitle,
      promptContent: dlpContent,
      promptOkFn: dlpOkFn,
    });
    openPrompt();
  };

  return {
    onSetDefaultLanding,
  };
}
